// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
// import { Button } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import actions from "model/actions";
import selectors from "model/selectors";
import ServiceDeskForm from "components/ServiceDeskForm";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./ServiceDesk.m.scss";

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      sdRequestLoading: selectors.clients.sdRequestLoading$$(state),
      sdRequestCompleted: selectors.clients.sdRequestCompleted$$(state),
      sdRequestError: selectors.clients.sdRequestError$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    createSupportTicket: actions.clients.createSupportTicket,
    clearSupportTicketRequest: actions.clients.clearSupportTicketRequest,
  }
)
@themr("ServiceDesk", styles)
export default class ServiceDesk extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    sdRequestLoading: PropTypes.bool,
    sdRequestCompleted: PropTypes.bool,
    sdRequestError: PropTypes.bool,
    createSupportTicket: PropTypes.func,
    clearSupportTicketRequest: PropTypes.func,
    history: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
  };

  handleSubmit = (conf) => {
    this.props.createSupportTicket(conf);
  };

  componentWillUnmount() {
    this.props.clearSupportTicketRequest();
  }

  render() {
    const {
      theme,
      sdRequestLoading,
      sdRequestCompleted,
      sdRequestError,
      clearSupportTicketRequest,
      history,
      match,
      basePath,
    } = this.props;

    return (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.content)}>
          <ServiceDeskForm
            onSubmit={this.handleSubmit}
            onNewRequest={clearSupportTicketRequest}
            onPageExit={() => {
              history.push(`${basePath}/${match.params.clientId}/menu`);
            }}
            requestInProgress={sdRequestLoading}
            requestCompleted={sdRequestCompleted}
            error={sdRequestError}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ServiceDesk/ServiceDesk.js